export default __webpack_public_path__ + "static/add-agent-dark-d3de8a371dd7d17ca0b9af65dd7e667d.png";